import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface ISectionCardProps {
  header: ReactNode;
  children?: ReactNode;
  className?: string;
}

export const SectionCard = ({
  header,
  children,
  className,
}: ISectionCardProps) => {
  return (
    <div
      className={twMerge(
        "flex flex-col bg-gray-v2-100 rounded-xl text-gray-v2-900",
        className
      )}
    >
      <div className="px-4 py-3 flex flex-col gap-0.5 text-lg font-semibold">
        {header}
      </div>
      {children}
    </div>
  );
};
